import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  token = '';
  hidePassword = true;
  hideConfirm = true;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) {
      this.router.navigate(['/login']);
      return;
    }

    this.form = this.fb.group({
      novaSenha: ['', [Validators.required, Validators.minLength(6)]],
      confirmarSenha: ['', [Validators.required]],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) return;

    const { novaSenha, confirmarSenha } = this.form.value;
    if (novaSenha !== confirmarSenha) {
      this.snackBar.open('As senhas nao coincidem', 'OK', { duration: 3000 });
      return;
    }

    this.loading = true;
    this.auth.resetPassword(this.token, novaSenha).subscribe({
      next: () => {
        this.snackBar.open('Senha redefinida com sucesso!', 'OK', {
          duration: 3000,
          panelClass: ['snackbar-success'],
        });
        this.router.navigate(['/login']);
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
